/**
 * Client-facing SMS consent disclosure shown on the advisor enrollment screen.
 *
 * This copy is filed verbatim with the AWS End User Messaging 10DLC campaign
 * registration as the opt-in workflow evidence: the carrier reviewer compares a
 * screenshot of the enrollment dialog against the registered program text. The
 * frequency line, the "Message and data rates may apply" line and the HELP/STOP
 * line must match the registration character-for-character, so they live here as
 * the single source of truth rather than inline in a template. Amend the
 * campaign registration before you change any string in this file, and bump
 * SMS_CONSENT_VERSION in the same commit so stored consent records stay diffable.
 */

export const SMS_CONSENT_VERSION = '2026-09-15'

export const SMS_CONSENT_INTRO =
  'Keep Rising Unlimited LLC (Keep Rising) will send this participant daily ' +
  'positive-action check-ins, appointment reminders, and replies from their ' +
  'advisor by text message.'

export const SMS_CONSENT_FREQUENCY_AND_RATES =
  'Up to 4 msgs/day. Message and data rates may apply.'

export const SMS_CONSENT_KEYWORDS = 'Reply HELP for help, STOP to cancel.'

export const SMS_TERMS_LABEL = 'SMS Terms'
export const SMS_TERMS_URL = 'https://keeprising.io/sms-terms/'

export const PRIVACY_POLICY_LABEL = 'Privacy Policy'
export const PRIVACY_POLICY_URL = 'https://keeprising.io/privacy-policy/'

/**
 * The disclosure exactly as it renders on screen, flattened to a single string
 * for the consent audit record. The link URLs are spelled out so the stored
 * record stands on its own if the pages are ever moved.
 */
export const SMS_CONSENT_DISCLOSURE = [
  SMS_CONSENT_INTRO,
  SMS_CONSENT_FREQUENCY_AND_RATES,
  SMS_CONSENT_KEYWORDS,
  `${SMS_TERMS_LABEL} (${SMS_TERMS_URL}) · ${PRIVACY_POLICY_LABEL} (${PRIVACY_POLICY_URL})`,
].join('\n\n')

export const SMS_CONSENT_CHECKBOX_LABEL =
  'The participant has read, or has been read, the notice above and has agreed ' +
  'to receive these text messages at the number entered.'

export const EMAIL_CONSENT_CHECKBOX_LABEL =
  'I confirm the participant has agreed to receive daily prompts via email.'

/**
 * Carriers accept advisor-collected consent, but the record has to say how it
 * was collected — this is what makes the attestation defensible under audit.
 */
export const SMS_CONSENT_METHOD_LABEL = 'How was consent collected?'

export const SMS_CONSENT_METHODS = [
  { value: 'IN_PERSON', text: 'In person, during onboarding' },
  { value: 'BY_PHONE', text: 'By phone' },
  { value: 'SELF_ENTERED', text: 'Participant entered their own number' },
]
